import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Section } from '../Section/Section';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormActions = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(Section, Object.assign({
    marginBlockStart: "1000"
  }, domProps, tokenProps, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'FormActions',
    children: children
  }));
};
FormActions.displayName = 'FormActions';